'use client';

import { Button } from '@ahafood/ui/components/button';
import { assetPrefix } from '@ahm/api-wrappers-core';
import { ChevronLeft, SearchIcon } from 'lucide-react';
import Image from 'next/image';
import { useCityRoutes } from '@/hooks/use-city-navigation';
import { useRouter } from '@/i18n/routing';
import { useDetectWebInApp } from '@/lib/is-webinapp/use-detect-webinapp';

interface Store {
  _id: number;
  name: string;
  image_url: string;
  address: string;
  distance: number;
  page_id: number;
  ai_tags?: string[];
  nearest_branch?: {
    address: string;
  };
}

interface MobileHeroProps {
  store: Store;
  onToggleSearch: () => void;
}

export function NewMobileHero({ store, onToggleSearch }: MobileHeroProps) {
  const routes = useCityRoutes();
  const router = useRouter();
  const isWebinApp = useDetectWebInApp();
  const handleBack = () => {
    if (isWebinApp) {
      router.back();
      return;
    }

    const prevUrl = document.referrer || '';
    const isSameOrigin = prevUrl.startsWith(window.location.origin);
    const isRedirectFromStore = prevUrl.includes('/store/');

    if (!prevUrl || window.history.length <= 1) {
      router.push(routes.home);
      return;
    }

    if (isSameOrigin && !isRedirectFromStore) {
      router.back();
    } else {
      router.push(routes.home);
    }
  };

  return (
    <div className="relative">
      {/* Hero Image - Mobile */}
      <div className="relative h-48 overflow-hidden">
        <Button
          size="icon"
          variant="secondary"
          className="[&_svg]:size-6 flex-none rounded-full absolute top-4 left-4 z-10 hover:bg-neutral-20 transition-colors"
          onClick={handleBack}
          aria-label="Quay lại"
        >
          <ChevronLeft />
        </Button>
        <Button
          size="icon"
          variant="secondary"
          className="[&_svg]:size-6 flex-none rounded-full absolute top-4 right-4 z-10 hover:bg-neutral-20 transition-colors"
          onClick={onToggleSearch}
          aria-label="Bật tìm kiếm"
        >
          <SearchIcon />
        </Button>
        <Image
          src={
            store?.image_url && store.image_url.trim() !== ''
              ? store.image_url
              : `${assetPrefix}/static/images/empty-store.webp`
          }
          alt={store?.name ?? 'Store image'}
          fill
          className="object-cover"
          priority
        />
      </div>
    </div>
  );
}
